import { useMemo } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Placement } from "react-bootstrap/types";

import classNames from "classnames";

import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useMediaQuery from "hooks/useMediaQuery";

type CheckboxProps = {
  label?: React.ReactNode;
  children?: React.ReactNode;
  checked?: boolean;
  onClick?: (_e: React.MouseEvent) => void;
  onChange?: (_e: any) => void;
  className?: string;
  tooltip?: string;
  tooltipPlacement?: Placement;
  type?: "checkbox" | "radio";
};

const Checkbox = ({
  className,
  label,
  children,
  checked,
  onClick,
  onChange,
  tooltip,
  tooltipPlacement,
  type = "checkbox",
}: CheckboxProps) => {
  const { mobile } = useMediaQuery();

  const checkbox = useMemo(
    () => (
      <label
        className={classNames(
          "cursor-pointer h-[20px] hover:text-smart-teal flex items-center",
          checked && "text-smart-teal",
          className
        )}
        onClick={(e) => {
          onChange && onChange({ currentTarget: { checked: !checked } });
          onClick && onClick(e);
        }}
      >
        <div
          className={classNames(
            "w-[16px] h-[16px] border-0 flex items-center justify-center",
            type === "checkbox" ? "rounded" : "rounded-full",
            checked ? "bg-smart-teal" : "bg-black/10",
            !!children && "mr-[15px]"
          )}
        >
          {type === "checkbox" ? (
            <FontAwesomeIcon
              icon={faCheck}
              className={classNames(
                "text-white h-[16px] text-[9px]",
                !checked && "opacity-0"
              )}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircle}
              className={classNames(
                "text-white h-[16px] text-[9px] rounded-full",
                !checked && "opacity-0"
              )}
            />
          )}
        </div>
        {children
          ? children
          : typeof label === "string"
          ? `${label}`
          : label && label}
      </label>
    ),
    [checked, children, className, label, onChange, onClick, type]
  );

  if (tooltip) {
    return (
      <OverlayTrigger
        placement={tooltipPlacement}
        trigger={mobile ? [] : ["hover", "click"]}
        overlay={
          <Tooltip className="[&>.tooltip-inner]:max-w-[500px] pointer-events-none">
            {tooltip}
          </Tooltip>
        }
      >
        <div>{checkbox}</div>
      </OverlayTrigger>
    );
  }

  return checkbox;
};

export default Checkbox;
